import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  Avatar,
  Box,
  Button,
  DataListItem,
  Icon,
  RowsSkeletonLoader,
} from '@node-space/ui-components'
import { useMappedRoles } from 'hooks/useMappedRoles'

interface CompanyInfoProps {
  companyName: string
  companyDescription: string
  isLoading?: boolean
  onEditClickHandler: () => void
}

const CompanyInfo = ({
  companyName,
  companyDescription,
  isLoading,
  onEditClickHandler,
}: CompanyInfoProps) => {
  const { t } = useTranslation()
  const permissions = useMappedRoles()
  const hasCompanyInfoRolePermissions = permissions?.manageCompanyInfo?.canEdit ?? false

  return (
    <Box width="full" className="border border-stroke-static rounded-lg">
      <Box flex justify="between">
        <Box align="start">
          <h3 className="text-h3 text-foreground-prominent p-4">
            {t('bvnkNetwork.howOthersSeeYou')}
          </h3>
        </Box>
        {hasCompanyInfoRolePermissions && (
          <Box flex width="full" justify="end" className="flex-1" paddingT={8}>
            <Button
              variant="ghost"
              iconElement={<Icon name="SimplePencilCustom" />}
              testId="company-info-edit-button"
              onClick={onEditClickHandler}
            />
          </Box>
        )}
      </Box>

      <Box flexCol padding={16} align="center" gapY={12}>
        <Avatar type="entity" name={companyName ?? ''} size="large" />
        <p className="text-h2 text-foreground-prominent">{companyName}</p>
      </Box>

      {isLoading ? (
        <Box paddingB={12} paddingT={28} paddingX={16} className="gap-0">
          <RowsSkeletonLoader rows={1} />
        </Box>
      ) : (
        companyDescription && (
          <Box padding={16}>
            <DataListItem
              id={companyDescription}
              title={t('bvnkNetwork.description')}
              body={companyDescription}
              layout={'vertical'}
            />
          </Box>
        )
      )}
    </Box>
  )
}

export default CompanyInfo
